<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab href="#holiday" ripple>Holiday</v-tab>
      <!-- <v-tab href="#xxDay" ripple>xxDay</v-tab> -->
    </v-tabs>

    <component :is="currentView"></component>
  </div>
</template>

<script>
import holiday from './holiday.vue'

    export default {
        data () {
          return {
            currentView: null,
          }
        },
        components: {
          holiday
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/view/template/generali/main.vue